import React from 'react';
import './PogressSpinner.scss';

const ProgressSpinner = ({ label }) => {
  return (
    <React.Fragment>
      <div className="text-center mt-5">
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {label && <h3>{label}</h3>}
      </div>
    </React.Fragment>
  );
};

export default ProgressSpinner;
